import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100dvh', // better than 100vh on mobile browsers
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        px: 2, // padding on small screens
      }}
    >
      <Container maxWidth='sm'>
        <Stack spacing={2} alignItems='center' textAlign='center'>
          {/* Big code */}
          <Typography
            sx={{
              fontWeight: 800,
              lineHeight: 1,
              fontSize: { xs: 64, sm: 96 }, // responsive
            }}
          >
            404
          </Typography>

          {/* Title */}
          <Typography
            variant='h5'
            sx={{
              fontWeight: 700,
              fontSize: { xs: 20, sm: 24 },
            }}
          >
            Page not found
          </Typography>

          {/* Helper text */}
          <Typography
            variant='body1'
            color='text.secondary'
            sx={{
              maxWidth: 420,
              fontSize: { xs: 14, sm: 16 },
            }}
          >
            The page you’re looking for doesn’t exist or may have been moved.
          </Typography>

          {/* Actions */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            sx={{ width: '100%', pt: 1 }}
          >
            <Button variant='primary' size='large' fullWidth onClick={() => navigate('/')}>
              Go to Home
            </Button>

            <Button variant='secondary' size='large' fullWidth onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
